import { createSelector } from "@reduxjs/toolkit";

export const getChatSettings = createSelector(
    (store) => store.app.chatSettings,
    (data: any) => {
        const orgID = localStorage.getItem("orgID");
        if (!orgID) {
            return null;
        }
        return data[orgID] || null;
    }
);